import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { BorrowerSetupInternalStore } from '../stores';

export const useBorrowerSetupStore = () => useContext<{
  borrowerSetupInternalStore: BorrowerSetupInternalStore
}>(StoreContext);
